<template>
  <app-layout>
    <div class="bg-white shadow-lg p-4 lg:p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-7xl mb-10">
      <div class="flex flex-wrap justify-center relative">

        <div
            class="lg:absolute right-0 bg-beige font-bold text-dark-blue text-lg lg:-mr-16 py-2 w-full lg:w-auto text-center lg:px-16 uppercase">
          {{ $trans('app.package') }} {{ $trans('app.' + this.$page.props.submissionPackage) }}
        </div>

        <div class="w-full mt-3 lg:mt-0">
          <p class="uppercase text-sm font-bold text-medium-blue">Test : {{ $page.props.survey.title[$locale()] }}</p>
          <h2 class="text-2xl text-black my-2">{{ $trans('app.test.result-of-your-test') }}</h2>
          <p class="text-sm text-medium-blue">{{ $trans('app.test.test-date') + $page.props.submissionDate }}</p>
          <hr class="w-24 my-4 border-dark-blue">
        </div>

        <div class="flex flex-wrap lg:flex-nowrap justify-between w-full mt-2 lg:mt-6 relative">
          <back-button class="lg:absolute left-0"></back-button>
          <h2 class="mt-4 lg:mt-0 text-dark-blue text-2xl font-bold mx-auto max-w-2xl text-center">
            {{ $page.props.skill.title[$locale()] }}</h2>
        </div>

        <div
            class="flex flex-wrap mg:flex-nowrap items-center justify-center bg-light-blue py-4 px-6 rounded-xl mt-8 mb-6 lg:mb-16">
          <p class="capitalize">{{ $trans('app.test.your-result') }} : </p>
          <p class="py-1 px-3 lg:ml-2 font-bold rounded-xl uppercase" :class="level($page.props.level)">
            {{ $trans('app.test.' + $page.props.level) }}</p>
        </div>

        <div class="md:flex flex-wrap lg:flex-nowrap items-start w-full">
          <div class="md:ml-20 relative z-10 flex-shrink-0 w-full md:w-1/2 md:order-2 mb-6 md:mb-0">
            <div class="rounded-xl overflow-hidden w-full max-w-3xl">
              <video-player id="video" :options="videoOptions">
                <source :src="route('video', [$page.props.submissionId, $page.props.skill.id])" type="video/mp4">
              </video-player>
              <img src="/images/bullet.svg" alt="bullets"
                   class="hidden md:block absolute top-0 right-0 transform translate-x-10 -translate-y-10 z-0">
            </div>
          </div>

          <div class="flex-1 md:order-1">
            <h3 class="mb-2">{{ $trans('app.test.definition') }}</h3>
            <p v-html="$page.props.skill.definition[$locale()]"></p>

            <h3 class="mt-8 mb-2">{{ $trans('app.test.objective') }}</h3>
            <p v-html="$page.props.skill.objective[$locale()]"></p>
          </div>
        </div>

      </div>

      <hr class="border-blue-200 my-12">

      <!--Signals-->
      <div class="grid lg:grid-cols-2 gap-8" id="skills">
        <div class="bg-light-blue text-dark-blue rounded-2xl p-4 lg:p-8">
          <h3 class="text-center">{{ $trans('app.test.example-weak-signals') }}</h3>
          <hr class="border-dark-blue my-8 w-2/5 mx-auto">
          <p v-for="signal in weakSignals" :key="signal" class="mb-3" v-html="signal.content[$locale()]"></p>
        </div>

        <div class="bg-light-blue text-dark-blue rounded-2xl p-4 lg:p-8">
          <h3 class="text-center">{{ $trans('app.test.example-strong-signals') }}</h3>
          <hr class="border-dark-blue my-8 w-2/5 mx-auto">
          <p v-for="signal in strongSignals" :key="signal" class="mb-3" v-html="signal.content[$locale()]"></p>
        </div>
      </div>

      <hr class="border-blue-200 my-12">

      <!--Levels-->
      <div class="mb-12">
        <div class="lg:w-1/2 pr-10">
          <h2 class="text-2xl text-black mt-2 mb-6">{{ $trans('app.test.level') }}
            {{ $trans('app.test.' + $page.props.level) }}</h2>

          <ul class="list-disc list-inside leading-loose">
            <li v-for="level in $page.props.levelStatement">{{ level.content[$locale()] }}</li>
          </ul>
        </div>
        <div class="bg-light-blue text-dark-blue rounded-2xl p-4 lg:px-8 lg:py-6 mt-6">
          <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-10 w-10 mr-4 flex-shrink-0" fill="none" viewBox="0 0 24 24"
                 stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            <strong class="text-xl mr-4 break-words">{{ $trans('app.test.advice-action-plan') }}</strong>
          </div>
          <ul class="mt-4 list-disc list-inside">
            <li class="mb-2" v-for="level in $page.props.levelAdvice">{{ level.content[$locale()] }}</li>
          </ul>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import BubbleButton from '@/Components/BubbleButton'
import BackButton from '@/Components/BackButton'
import VideoPlayer from "@/Components/VideoPlayer";

export default {
  components: {AppLayout, BubbleButton, BackButton, VideoPlayer},

  data() {
    return {
      videoOptions: {
        fluid: true,
        height: 200,
        controls: true,
      }
    }
  },

  computed: {
    strongSignals() {
      return this.$page.props.skill.signals.filter((s) => {
        return s.type === 'strong';
      });
    },
    weakSignals() {
      return this.$page.props.skill.signals.filter((s) => {
        return s.type === 'weak';
      });
    },
  },

  methods: {
    level(result) {
      switch (result) {
        case ('develop'):
          return 'bg-red-100 text-red-600';
          break;
        case ('improve'):
          return 'bg-yellow-100 text-yellow-600';
          break;
        case ('maintain'):
          return 'bg-green-100 text-green-600';
          break;
      }
    }
  }
}
</script>

<style>

</style>
